export default {"src":"/_next/static/media/voiceMessage.309b3d7d.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};